import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { SeoWeb } from './pages/SeoWeb';
import { OnlineAds } from './pages/OnlineAds';
import { PosterLogo } from './pages/PosterLogo';
import { Web } from './pages/Web';
import { Video } from './pages/Video';
import { Services } from './pages/Services';
import DataService from './services/data.service';

function App() {
  setTimeout(() => {
    DataService.keepAlive();
  }, 1800000);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='/services' element={<Services />}></Route>
          <Route path='/services/seo-and-web-analytics' element={<SeoWeb />}></Route>
          <Route path='/services/online-advertisement' element={<OnlineAds />}></Route>
          <Route path='/services/poster-and-logo-design' element={<PosterLogo />}></Route>
          <Route path='/services/web-design-and-development' element={<Web />}></Route>
          <Route path='/services/video-editing-and-animation' element={<Video />}></Route>
          <Route path='/contact' element={<Contact />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;